import ContentCenterSmallImageCenter from '@/components/FormGenericComponents/InteractiveForm/InteractiveHomePageLayouts/ContentCenterSmallImageCenter'

export default {
    name: "InteractiveHomePageMobileView",
    functional: true,
    render(h, ctx) {
        return h(ContentCenterSmallImageCenter, ctx.data)
    }
}